exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.IA_ButtonContainer_3v3SdeO5jzibjFUSnraFq8 {\n\n  width: 100%;\n  display: flex;\n  margin-bottom: 20px;  \n\n}\n\n\n.IA_dropZones_8V6UsXrfWjxVOlTpA87Lh {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_ButtonContainer": "IA_ButtonContainer_3v3SdeO5jzibjFUSnraFq8",
	"IA_dropZones": "IA_dropZones_8V6UsXrfWjxVOlTpA87Lh"
};